export const selectSchool = payload => {
  return {
    type: 'SELECTED_SCHOOL:SET',
    payload,
  };
};

export const setWindowSize = () => (dispatch, getState) => {
  dispatch({ type: 'APP:WINDOW_RESIZE' });
};



// WEBPACK FOOTER //
// ./src/actions.js